import React, { Component } from "react";
import { CurrencyUtil, StringUtil } from "@eres/core";
import TextInputField, { Props as TFProps } from "./TextInputField";
import { DefaultProps } from "@eres/forms";
import CurrencyConverter from "@eres/forms/converters/CurrencyConverter";
import Strings from "@my-dld/assets/strings";

export interface Props extends TFProps {
	containerClassName?: string;
	inputGroupClassName?: string;
	inputClassName?: string;
	currencyTypeClassName?: string;
	errorInputClass?: string;
	placeHolder?: string;
	currencyType?: string;
}

interface State {
}

class CurrencyInput extends Component<Props, State> {
	static defaultProps: DefaultProps<Props> = {
		valueConverter: [ CurrencyConverter ]
	};

	render() {
		return <TextInputField
			{ ...this.props }
			suffix={ Strings.aed }
			extraInputClassName={ "text-end" }
			cursorPositioner={ CursorPositioner }/>;
	}

}

export function CursorPositioner( previousValue: string | null, previousPosition: number, value: string ): number {
	if ( StringUtil.isEmptyStringOrNull( previousValue! ) )
		return 1;
	let p = CurrencyUtil.convertValueToCurrency( previousValue! )!;
	let c = CurrencyUtil.convertValueToCurrency( value! )!;
	c = c ? c : "";
	p = p ? p : "";
	let inc = p.split( "," ).length - 1;
	let ouc = c.split( "," ).length - 1;
	if ( p === c ) return previousPosition - 1;
	if ( inc !== ouc ) {
		if ( inc < ouc ) return previousPosition + 1;
		if ( inc > ouc ) return previousPosition - 1;
	}
	return previousPosition;
}

export default CurrencyInput;
